import {IBet, ICommentAll, IPaginationFetch} from '../types';
import socket from '../socket';
import {apiAxios} from '../api/config';
import axios from "axios";
import {BASE_URL, CONFIG} from "../constants";


export class RestBids {

    static ping(): Promise<any> {
        return new Promise(async () => {
            try {
                await axios.get(BASE_URL + '/bids/ping', CONFIG);
            } catch (error) {
                console.error('Error:', error);
            }
        })
    }

    static exit(): Promise<any> {
        return new Promise(async () => {
            try {
                await axios.get(BASE_URL + '/bids/exit', CONFIG);
            } catch (error) {
                console.error('Error:', error);
            }
        })
    }

    static setBet(payload: IBet): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('set-bet', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static getAllBids(payload: IPaginationFetch): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('get-all-bids', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static updateBet(payload: IBet): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('update-bet', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static setIsArchive(payload: IBet): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('set-archive', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static filtersBits(payload: {}): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('filters-bits', payload, (response: any) => {
                    resolve(response)
                })
                socket.off('filters-bits')
            } catch (e) {
                reject(e)
            }
        });
    }

    static getFiltersBits(payload: {}): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('get-filters-bits', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static getAllBidsArchive(payload: IPaginationFetch): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('get-all-bids-archive', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static searchBits(payload: IPaginationFetch): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('search-bits', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static commentAll(payload: ICommentAll): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('comment-all', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static commentDelete(payload: ICommentAll): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('comment-delete', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static getAllBidsExcel(payload: {}): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('get-all-bids-excel', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static updateAllDepartment(payload: {}): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('update-bet-all', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static getCity(payload: { locale: string }): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('get-city', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static deleteCity(payload: { id: string, locale: string }): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('delete-city', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static updateCity(payload: { id: string, text: string, old: string, locale: string }): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('update-city', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static getCountry(payload: { locale: string }): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('get-country', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static updateCountry(payload: { id: string, text: string, old: string }): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('update-country', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static searchCountry(payload: { value: string, locale: string }): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('search-country', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static searchCity(payload: { value: string, locale: string }): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('search-city', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static searchLocation(payload: { value: string, locale: string }): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('search-location', payload, ((response: any) => {
                    resolve(response)
                }));
            } catch (e) {
                reject(e)
            }
        });
    }

    static massiveUpdateCountry(payload: []): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('massive-update-country', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static massiveUpdateCity(payload: []): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('massive-update-city', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static createCity(payload: { data: [], locale: string }): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('create-city', payload);
            } catch (e) {
                reject(e)
            }
        });
    }

    static async updateBidsRent(data: {}): Promise<any> {
        try {
            return apiAxios.post('bids/update/rent', data);
        } catch (err) {
            console.log(err);
            throw err;
        }
    }


}
